import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { IconComponent } from '@ansys-internal/awc-angular/icons';
import { DIALOG_DATA, DIALOG_REF } from '@ansys-internal/awf-angular/shared';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@ansys-internal/awc-angular/buttons';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'app-alert',
    imports: [ButtonComponent],
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.scss'
})
export class AlertComponent {
  protected type: ButtonType = ButtonType.PRIMARY;
  protected size: ButtonSize = ButtonSize.MEDIUM;

  constructor(
    @Inject(DIALOG_DATA) public data: { message?: string },
    @Inject(DIALOG_REF) public dialogRef: DialogRef,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ) {
    this.data = this.data || { message: '' };
  }

  ngOnInit(): void {
    this.cdr.detectChanges(); // Trigger a manual change detection
  }
}
